import { actionCreator } from 'utils';
import * as EmailTemplateTypes from '../types/emailTemplateTypes';

// L O A D   E M A I L   T E M P L A T E
export function loadEmailTemplate() {
    return {
        type: EmailTemplateTypes.LOAD_EMAIL_TEMPLATE,
    };
}

export function loadEmailTemplateRes(data) {
    return {
        type: actionCreator(EmailTemplateTypes.LOAD_EMAIL_TEMPLATE, 'res'),
        data,
    };
}

export function loadEmailTemplateErr() {
    return {
        type: actionCreator(EmailTemplateTypes.LOAD_EMAIL_TEMPLATE, 'err'),
    };
}
// L O A D   E M A I L   T E M P L A T E

// S E T   E M A I L   T E M P L A T E   F I L T E R S
export function setEmailTemplateFilters(key, value) {
    return {
        type: EmailTemplateTypes.SET_EMAIL_TEMPLATE_FILTERS,
        key,
        value,
    };
}
// S E T   E M A I L   T E M P L A T E   F I L T E R S

// R E S E T   E M A I L   T E M P L A T E   F I L T E R S
export function resetEmailTemplateFilters() {
    return {
        type: EmailTemplateTypes.RESET_EMAIL_TEMPLATE_FILTERS,
    };
}
// R E S E T   E M A I L   T E M P L A T E   F I L T E R S

// S E T   E M A I L   T E M P L A T E   P A G I N A T I O N
export function setEmailTemplatePagination(key, pagination) {
    return {
        type: EmailTemplateTypes.SET_EMAIL_TEMPLATE_PAGINATION,
        key,
        pagination,
    };
}
// S E T   E M A I L   T E M P L A T E   P A G I N A T I O N

// A D D   E M A I L   T E M P L A T E
export function addEmailTemplate(data) {
    return {
        type: EmailTemplateTypes.ADD_EMAIL_TEMPLATE,
        data,
    };
}

export function addEmailTemplateRes() {
    return {
        type: actionCreator(EmailTemplateTypes.ADD_EMAIL_TEMPLATE, 'res'),
    };
}

export function addEmailTemplateErr() {
    return {
        type: actionCreator(EmailTemplateTypes.ADD_EMAIL_TEMPLATE, 'err'),
    };
}
// A D D   E M A I L   T E M P L A T E

// E D I T   E M A I L   T E M P L A T E
export function editEmailTemplate(data) {
    return {
        type: EmailTemplateTypes.EDIT_EMAIL_TEMPLATE,
        data,
    };
}

export function editEmailTemplateRes() {
    return {
        type: actionCreator(EmailTemplateTypes.EDIT_EMAIL_TEMPLATE, 'res'),
    };
}

export function editEmailTemplateErr() {
    return {
        type: actionCreator(EmailTemplateTypes.EDIT_EMAIL_TEMPLATE, 'err'),
    };
}
// E D I T   E M A I L   T E M P L A T E

// L O A D   E D I T A B L E   E M A I L   T E M P L A T E
export function loadEditableEmailTemplate(id) {
    return {
        type: EmailTemplateTypes.LOAD_EDITABLE_EMAIL_TEMPLATE,
        id,
    };
}

export function loadEditableEmailTemplateRes(data) {
    return {
        type: actionCreator(EmailTemplateTypes.LOAD_EDITABLE_EMAIL_TEMPLATE, 'res'),
        data,
    };
}

export function loadEditableEmailTemplateErr() {
    return {
        type: actionCreator(EmailTemplateTypes.LOAD_EDITABLE_EMAIL_TEMPLATE, 'err'),
    };
}
// L O A D   E D I T A B L E   E M A I L   T E M P L A T E

// L O A D   E M A I L   T E M P L A T E   T A G S
export function loadEmailTemplateTags() {
    return {
        type: EmailTemplateTypes.LOAD_EMAIL_TEMPLATE_TAGS,
    };
}

export function loadEmailTemplateTagsRes(data) {
    return {
        type: actionCreator(EmailTemplateTypes.LOAD_EMAIL_TEMPLATE_TAGS, 'res'),
        data,
    };
}

export function loadEmailTemplateTagsErr() {
    return {
        type: actionCreator(EmailTemplateTypes.LOAD_EMAIL_TEMPLATE_TAGS, 'err'),
    };
}
// L O A D   E M A I L   T E M P L A T E   T A G S
